import { render, staticRenderFns } from "./center.vue?vue&type=template&id=8a2722ae"
import script from "./center.vue?vue&type=script&lang=js"
export * from "./center.vue?vue&type=script&lang=js"
import style0 from "./center.vue?vue&type=style&index=0&id=8a2722ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports